import React from 'react';
import get from 'lodash/get';
import { LazyImage } from 'project/lazy-image';
import { liveHole } from 'components/live-hole';

const CourseMap = ({ holes, courseMapSrc }) => {
    return (
        <div className="course__map-wrapper">
            <div className="course__map">
                <div className="course__map-img">
                    <LazyImage image={courseMapSrc} />
                </div>
                {holes.map((hole) => {
                    const positionOnTheMap = get(hole, 'sitecoreData.positionOnTheMap');

                    if (!positionOnTheMap) return null;

                    const positionOnTheMapStyles = {
                        bottom: `${positionOnTheMap.y}%`,
                        left: `${positionOnTheMap.x}%`
                    };

                    return <button
                        className="course__map-hole-flag hole-flag"
                        key={hole.id}
                        type="button"
                        style={positionOnTheMapStyles}
                        onClick={() => liveHole.show(hole.id)}
                    >{hole.id}</button>;
                })}
            </div>
        </div>
    );
};

export default CourseMap;
